import { createStore } from 'satcheljs';
var defaultDelayedSendStore = {
    delayedMailItems: [],
};
export var getStore = createStore('delayedSend', defaultDelayedSendStore);
export default getStore();
//# sourceMappingURL=store.js.map